"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Generated from cz.marbes.box.controller.DokumentBoxController.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:39:08Z                      #

// ##############################################################

var DokumentBoxApi = function () {
  function DokumentBoxApi() {
    (0, _classCallCheck3.default)(this, DokumentBoxApi);
  }

  (0, _createClass3.default)(DokumentBoxApi, null, [{
    key: "getRecipeStatus",

    /**
     * 
     *
     * @param recipeId 
     * @return 
     */
    value: function getRecipeStatus(recipeId) {
      var uri = serverContextPath + ("/api/dokumentbox/recipe/status/" + recipeId);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param recipeId 
     * @return 
     */

  }, {
    key: "getRecipeProgress",
    value: function getRecipeProgress(recipeId) {
      var uri = serverContextPath + ("/api/dokumentbox/recipe/progress/" + recipeId);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param recipeId 
     * @return 
     */

  }, {
    key: "waitForRecipeEnd",
    value: function waitForRecipeEnd(recipeId) {
      var uri = serverContextPath + ("/api/dokumentbox/recipe/wait/" + recipeId);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return 
     */

  }, {
    key: "getActiveModules",
    value: function getActiveModules() {
      var uri = serverContextPath + "/api/dokumentbox/sign/modules";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Ziska dostupnu uzivatelske certifikaty.
     *
     * @param moduleCode kod modulu, pro ktery ziskavame certifikaty
     * @param requestParam nepovinny parametr pro ziskani udaju o certifikatu
     * @return seznam informaci o certifikatech
     */

  }, {
    key: "findCertificates",
    value: function findCertificates(moduleCode, requestParam) {
      var uri = serverContextPath + "/api/dokumentbox/sign/certificates/list";
      var headers = undefined;
      var params = { moduleCode: moduleCode };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, requestParam, headers));
    }
  }]);
  return DokumentBoxApi;
}();

exports.default = DokumentBoxApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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